<template>
    <div class="career">
        <div class="nav">
            <div class="navs">
                <img src="imgs/careerhome/icon_xitong.png" alt="" class="xitong">
                <span class="title" style="color:#3D90F6">
                    生涯发展管理平台
                </span>
                <div class="navRight">
                    <img :src="person" alt="" style="width:42px">
                    <span>{{user.parentName||user.parentPhone}}</span>&nbsp; | &nbsp;
                    <a @click="Jump('/login')" style="color:#3D90F6">退出</a>
                </div>
            </div>
        </div>
        <div class="careerBox">
            <div class="left">
                <ul class="routers">
                    <router-link  tag="li" :to="quesPath" class="unactive"><img src="/imgs/careerhome/nav/icon_shouye.png" alt="">首页</router-link>
                    <template v-if="parentStatus==3">
                        <router-link  tag="li" to="/parent/main" class="active"><img src="/imgs/careerhome/nav/icon_waibutansuo.png" alt="">咨询管理</router-link>
                    </template>
                </ul>
            </div>
            <div class="right">
                <div class="rightBottom">
                    <!--<transition name="transitionRouter">-->
                    <router-view></router-view>
                    <!--</transition>-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "parentIndex",
    data(){
        return {
            routers:[
                { name:'首页', path:'/parent/home/ques'},
                { name:'外部探索',path:'/explore'},
                { name:'咨询管理',path:'/parent/main'},
                { name:'视频课程',path:'/videoCourse'}
            ],
            imgs:[
                "imgs/careerhome/nav/icon_shouye",
                "imgs/careerhome/nav/icon_waibutansuo",
                "imgs/careerhome/nav/icon_shipinkecheng"
            ],
            message:['imgs/careerhome/icon_tongzhi.png','imgs/careerhome/icon_youxiaoxi.png'],
            person:'imgs/careerhome/icon_boy.png',
            uName:sessionStorage.getItem('parentName'),
            noticeNumber:0,
            days:'',
            hours:'',
            minutes:'',
            seconds:'',
            teacherId:''
        }
    },

    computed:{
        //用户信息
        user(){
            return this.$store.state.parentInfo;
        },
        unreadNum(){
            return this.$store.state.notice.unreadNum
        },
        parentStatus() {
            return this.$store.state.parentStatus;
        },
        quesPath() {
            if(this.$store.state.parentStatus!=3) {
                return '/parent/home/ques'
            }else {
                return '/parent/home/quesMessage'
            }
        }

    },
    watch: {
        user(val){
            this.uName=val.name;
            this.teacherId=val.teacher_id;
            if(val.sex==1){
                this.person='imgs/careerhome/icon_boy.png'
            }else{
                this.person='imgs/careerhome/icon_girl.png'
            }
            this.countDown(val.baccll_year)
            setInterval(()=>{
                this.countDown(val.baccll_year)
            },1000)
        },
    },
    created() {
        let token= window.sessionStorage.getItem('ymtxToken');
        window.sessionStorage.setItem('token', token);

        ///获取个人信息
        this.$store.dispatch({
            type:'getUserInfo',
            token:token,
            vue:this
        });

        //获取未读通知
        // this.$store.dispatch('getUnreadNum',token);
        // 获取家长消息
        this.$store.dispatch('detailParentInfo');
        this.detailParentCensusQuestion();
        this.$store.dispatch('getParentStatus',token);
    },
    mounted(){

    },
    methods:{
        // 获取当前家长问卷填写状态
        detailParentCensusQuestion() {
            this.$ajax.post(this.G_acapi+this.ports.parent.message.detailParentCensusQuestion,{
            },{
                headers:{
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res)=>{
                if(res.data.code==2000){
                    let status = res.data.data.status;
                    this.$store.commit('getParentStatus',status);
                }
            })
        },
        //高考倒计时
        countDown(year){
            let time=new Date(year,5,7).getTime()/1000;
            let nowTime=new Date().getTime()/1000;
            this.days=Math.floor((time-nowTime)/3600/24)
            this.hours=Math.floor((time-nowTime)/3600%24)
            this.minutes=Math.floor((time-nowTime)/60%60)
            this.seconds=Math.floor((time-nowTime)%60)
            this.hours=this.hours<10?"0"+this.hours:this.hours
            this.minutes=this.minutes<10?"0"+this.minutes:this.minutes
            this.seconds=this.seconds<10?"0"+this.seconds:this.seconds
        },
        Jump(path){
            window.sessionStorage.clear();
            this.$router.push(path);
        }
    },
}
</script>

<style scoped lang="less">
.career{
    // padding-bottom: 20px;
    height: 100%;
    .nav{
        width: 100%;
        height: 66px;
        background: #fff;
        overflow: hidden;
        .navs{
            width: 1200px;
            height: 100%;
            position: relative;
            margin:0 auto;
            line-height:66px;
            font-size:13px;
            color:#333;
            .navRight{
                position: absolute;
                right: 0;
                top: 0;
                width: auto;
                height: 100%;
                span{
                    letter-spacing: 2px;
                }
                img{
                    margin-right: 10px;
                }
                .tongzhi{
                    margin-right:40px;
                }
                .tongzhiImg{
                    cursor: pointer;
                }
                a{
                    color:#333;
                    letter-spacing: 1.5px;
                }
            }
            .xitong{
                width: 36px;
                height: auto;
                margin-right:5px;
                position: relative;
                top:-1px;
            }
            .rili{
                margin-right: 5px;
            }
            .title{
                font-size: 17px;
                color:#333333;
                letter-spacing: 2px;
                text-align: center;
                font-weight: bolder;
                margin-right: 38px;
            }
            .number{
                color:red;
                margin-right: 3px;
                font-weight: bolder;
            }
        }
    }
    .careerBox{
        width: 1200px;
        margin: 20px auto;
        display: flex;
        align-items: flex-start;
        .left{
            width: 210px;
            //height: 120px;
            margin-top: 1px;
            background: #fff;
            border-radius: 3px;
            box-shadow: 0 0 3px #dedede;
            position: relative;
            z-index: 3;
            .routers{
                li{
                    line-height: 60px;
                    height: 60px;
                    width: 100%;
                    font-size: 15px;
                    text-indent: 42px;
                    color:#666;
                    cursor: pointer;
                    transition: 0.2s;
                    &:nth-child(1){
                        line-height: 60px;
                        height: 60px;
                        font-size: 16px;
                        border-bottom: 1px solid #F7F6FB;
                        font-weight: normal;
                    }
                    img{
                        margin-right: 15px;
                        position: relative;
                        top:-2px;
                    }
                    .active {
                        display: none;
                    }
                    .unactive {
                        display: inline-block;
                    }
                }
                .router-link-active {
                    color:#3C8CEB;
                }
                .home {
                    background: none;
                    .active {
                        display: none;
                    }
                    .unactive {
                        display: inline-block;
                    }
                }
            }
        }
        .right{
            box-sizing: border-box;
            // flex: 1;
            padding-left: 20px;
            width: 990px;
            .rightTop{
                width: 100%;
                height: 65px;
                background: #fff;
                border-radius: 3px;
                box-shadow: 0 0 3px #dedede;
            }
        }
    }
}
</style>

